import { defineMessages } from "react-intl";

const messages = defineMessages({
  emailVariantLayoutMessage: {
    id: "settings.formLayouts.canvas.activityRequiredRelationshipAlert.emailVariantLayoutMessage",
    defaultMessage:
      "Ability to send bulk emails within MMC is limited because at least one relationship record field is required on this variant.",
    description: "Alert message for email variant layout",
  },
  primaryLayoutMessage1: {
    id: "settings.formLayouts.canvas.activityRequiredRelationshipAlert.primaryLayoutMessage1",
    defaultMessage:
      "Ability to send bulk emails is limited because at least one relationship record field is required",
    description: "Alert first message for primary layout",
  },
  primaryLayoutMessage2: {
    id: "settings.formLayouts.canvas.activityRequiredRelationshipAlert.primaryLayoutMessage2",
    defaultMessage:
      "To fully enable bulk emails, create an Email Variant and mark all relationship record fields as “not required”",
    description: "Alert second message for primary layout",
  },
  resetButton: {
    id: "settings.formLayouts.canvas.activityRequiredRelationshipAlert.resetButton",
    defaultMessage: "Reset",
    description: "Alert reset button",
  },
});

export default messages;
